import Layout from '../../components/layout/Layout'

const UserManual = () => {
  return (
    <Layout>
      <div className="bg-white rounded-lg shadow p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">User Manual</h1>
        <p className="text-gray-600">
          Comprehensive guide for using the system
        </p>
      </div>
    </Layout>
  )
}

export default UserManual
